export const SET_ACTIVE_DESIGN_PAGE = 'designTab/SET_ACTIVE_PAGE';
export const setActiveDesignPage = (payload = -1) => ({
  type: SET_ACTIVE_DESIGN_PAGE,
  payload,
});



// WEBPACK FOOTER //
// ./app-settings/actions/set-active-design-page.js